import angular from 'angular';

module.exports = angular.module('market.routes.unsubscribed-customer', [
  require('angular-ui-router')
])
.config(function($stateProvider) {
  $stateProvider.state('unsubscribe', {
    parent: 'root',
    url: '/unsubscribed',
    template: require('./unsubscribed-customer.jade')(),
  });
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/routes/unsubscribed-customer.js
 **/